import React, { useRef, useState } from 'react';
import { appConfig, configValue, versionValue, commitValue } from 'cd-eft/config/AppConfig';
import { DiagnosticVM } from './DiagnosticVM';
import { observer } from 'mobx-react-lite';


export const DiagnosticView = observer(() => {

    const vmREF = useRef<DiagnosticVM>();
    if (!vmREF.current) {
        vmREF.current = new DiagnosticVM();
        vmREF.current.initialize();
    }
    const vm = vmREF.current;
    // const 


    return (
        <table>
            <tr>
                <th>configValue:</th>
                <td>{configValue}</td>
            </tr>
            <tr>
                <th>versionValue:</th>
                <td>{versionValue}</td>
            </tr>
            <tr>
                <th>commitValue:</th>
                <td>{commitValue}</td>
            </tr>
            <tr>
                <th>&nbsp;</th>
            </tr>
            <tr>
                <th>configVersion:</th>
                <td>{appConfig.configVersion}</td>
            </tr>
            <tr>
                <th>environmentName: </th>
                <td>{appConfig.environmentName}</td>
            </tr>
            <tr>
                <th>useEAuth: </th>
                <td>{appConfig.useEAuth.toString()}</td>
            </tr>
            <tr>
                <th>eAuthBasePath: </th>
                <td>{appConfig.eAuthBasePath}</td>
            </tr>

            <tr>
                <th>delineateWatershedGpApiConfig: </th>
                <td>{appConfig.hydrologyRefactorGpApiConfig.baseUrl}</td>
            </tr>

            <tr>
                <th>surfaceDesignGpApiConfig: </th>
                <td>{appConfig.surfaceDesignGpApiConfig.basePath}</td>
            </tr>

            <tr>
                <th>&nbsp;</th>
            </tr>
            <tr>
                <th>AUTH_API: </th>
                <td>{appConfig.endpoints.eftAuthenApiBasePath}</td>
            </tr>
            <tr>
                <th>auth_available: </th>
                <td>{vm.auth_available}</td>
            </tr>
            <tr>
                <th>auth_profile: </th>
                <td>{vm.auth_profile}</td>
            </tr>
            <tr>
                <th>auth_name: </th>
                <td>{vm.auth_name}</td>
            </tr>
            <tr>
                <th>auth_version: </th>
                <td>{vm.auth_version}</td>
            </tr>


            <tr>
                <th>&nbsp;</th>
            </tr>
            <tr>
                <th>CLEAN_API: </th>
                <td>{appConfig.endpoints.eftCleaningApiBasePath}</td>
            </tr>
            <tr>
                <th>clean_available: </th>
                <td>{vm.clean_available}</td>
            </tr>
            <tr>
                <th>clean_profile: </th>
                <td>{vm.clean_profile}</td>
            </tr>
            <tr>
                <th>clean_name: </th>
                <td>{vm.clean_name}</td>
            </tr>
            <tr>
                <th>clean_version: </th>
                <td>{vm.clean_version}</td>
            </tr>
            <tr>
                <th>clean_core_name: </th>
                <td>{vm.clean_core_name}</td>
            </tr>
            <tr>
                <th>clean_core_version: </th>
                <td>{vm.clean_core_version}</td>
            </tr>


            <tr>
                <th>&nbsp;</th>
            </tr>
            <tr>
                <th>HYRDO_API: </th>
                <td>{appConfig.endpoints.eftEfh2ApiBasePath}</td>
            </tr>
            <tr>
                <th>hydro_available: </th>
                <td>{vm.hydro_available}</td>
            </tr>
            <tr>
                <th>hydro_profile: </th>
                <td>{vm.hydro_profile}</td>
            </tr>
            <tr>
                <th>hydro_name: </th>
                <td>{vm.hydro_name}</td>
            </tr>
            <tr>
                <th>hydro_version: </th>
                <td>{vm.hydro_version}</td>
            </tr>
            <tr>
                <th>hydro_core_name: </th>
                <td>{vm.hydro_core_name}</td>
            </tr>
            <tr>
                <th>hydro_core_version: </th>
                <td>{vm.hydro_core_version}</td>
            </tr>



            <tr>
                <th>&nbsp;</th>
            </tr>
            <tr>
                <th>PROJ_API: </th>
                <td>{appConfig.endpoints.eftPrjAdminApiBasePath}</td>
            </tr>
            <tr>
                <th>proj_available: </th>
                <td>{vm.proj_available}</td>
            </tr>
            <tr>
                <th>proj_profile: </th>
                <td>{vm.proj_profile}</td>
            </tr>
            <tr>
                <th>proj_name: </th>
                <td>{vm.proj_name}</td>
            </tr>
            <tr>
                <th>proj_version: </th>
                <td>{vm.proj_version}</td>
            </tr>
            <tr>
                <th>proj_core_name: </th>
                <td>{vm.proj_core_name}</td>
            </tr>
            <tr>
                <th>proj_core_version: </th>
                <td>{vm.proj_core_version}</td>
            </tr>



            <tr>
                <th>&nbsp;</th>
            </tr>
            <tr>
                <th>SURF_API: </th>
                <td>{appConfig.endpoints.eftSetApiBasePath}</td>
            </tr>
            <tr>
                <th>surf_available: </th>
                <td>{vm.surf_available}</td>
            </tr>
            <tr>
                <th>surf_profile: </th>
                <td>{vm.surf_profile}</td>
            </tr>
            <tr>
                <th>surf_name: </th>
                <td>{vm.surf_name}</td>
            </tr>
            <tr>
                <th>surf_version: </th>
                <td>{vm.surf_version}</td>
            </tr>
            <tr>
                <th>surf_core_name: </th>
                <td>{vm.surf_core_name}</td>
            </tr>
            <tr>
                <th>surf_core_version: </th>
                <td>{vm.surf_core_version}</td>
            </tr>
            <tr>
                <th>surf_framework_name: </th>
                <td>{vm.surf_framework_name}</td>
            </tr>
            <tr>
                <th>surf_framework_version: </th>
                <td>{vm.surf_framework_version}</td>
            </tr>





        </table>
    );
});